import { enablePointerEvents } from '@utils/pointer-events-control';

let cam;

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'StartScene',
    });
  }

  preload() {}

  create() {
    if (window.isLocalHost) enablePointerEvents();

    // GameScene UI sprites (preloaded here to keep parity with the original)
    this.load.image('mask', 'assets/GameUIAnims/mask.png');
    this.load.image('progressBar', 'assets/GameUIAnims/progressBar.png');
    this.load.image('holder', 'assets/GameUIAnims/holder.png');
    this.load.image('settings', 'assets/GameUIAnims/settings.png');
    this.load.image('yellow', 'assets/GameUIAnims/yellow.png');
    this.load.image('circle', 'assets/GameUIAnims/circle.png');
    this.load.image('dropDown', 'assets/GameUIAnims/dropDown.png');
    this.load.image('fullScreenOff', 'assets/GameUIAnims/fullScreenOff.png');
    this.load.image('fullScreen', 'assets/GameUIAnims/fullScreen.png');
    this.load.image('sound', 'assets/GameUIAnims/sound.png');
    this.load.image('mute', 'assets/GameUIAnims/mute.png');
    this.load.image('paused', 'assets/GameUIAnims/paused.png');

    // GameScene UI animations (Tera character states)
    this.load.multiatlas(
      'playAnim',
      'assets/GameUIAnims/Tera Animations/playPauseAnim.json',
      'assets/GameUIAnims/Tera Animations',
    );
    this.load.multiatlas(
      'teraIn',
      'assets/GameUIAnims/Tera Animations/teraAppearAnim.json',
      'assets/GameUIAnims/Tera Animations',
    );
    this.load.multiatlas(
      'teraIdle',
      'assets/GameUIAnims/Tera Animations/teraIdleBlinkAnim.json',
      'assets/GameUIAnims/Tera Animations',
    );
    this.load.multiatlas(
      'teraCorrect',
      'assets/GameUIAnims/Tera Animations/teraCorrectAnim.json',
      'assets/GameUIAnims/Tera Animations',
    );
    this.load.multiatlas(
      'teraWrong',
      'assets/GameUIAnims/Tera Animations/teraWrongAnim.json',
      'assets/GameUIAnims/Tera Animations',
    );
    this.load.multiatlas(
      'teraThink',
      'assets/GameUIAnims/Tera Animations/teraThinkAnim.json',
      'assets/GameUIAnims/Tera Animations',
    );
    this.load.multiatlas(
      'teraIdea',
      'assets/GameUIAnims/Tera Animations/teraIdeaAnim.json',
      'assets/GameUIAnims/Tera Animations',
    );
    this.load.multiatlas(
      'teraOut',
      'assets/GameUIAnims/Tera Animations/teraOutAnim.json',
      'assets/GameUIAnims/Tera Animations',
    );

    // EndScene
    this.load.image('gameOver', 'assets/EndSceneAssets/Game Over.png');
    this.load.image('youWon', 'assets/EndSceneAssets/You won.png');
    this.load.image('correctIcon', 'assets/EndSceneAssets/correctIcon.png');
    this.load.image('incorrectIcon', 'assets/EndSceneAssets/incorrectIcon.png');
    this.load.image('retryButton', 'assets/EndSceneAssets/Retry Button.png');
    this.load.image('hover_retryButton', 'assets/EndSceneAssets/hover_Retry Button.png');
    this.load.image('hintIconMini', 'assets/EndSceneAssets/endHint.png');
    this.load.image('nextButton', 'assets/EndSceneAssets/nextButton.png');
    this.load.image('hover_nextButton', 'assets/EndSceneAssets/hover_nextbutton.png');
    this.load.image('replayButton', 'assets/EndSceneAssets/replayButton.png');
    this.load.image('hover_replayButton', 'assets/EndSceneAssets/hover_replayButton.png');
    this.load.image('endScreenOverlay', 'assets/EndSceneAssets/end screen.png');
    this.load.image('okayButton', 'assets/EndSceneAssets/okaybutton.png');
    this.load.image('hover_okayButton', 'assets/EndSceneAssets/hover_okaybutton.png');
    this.load.image('disable_okayButton', 'assets/EndSceneAssets/disable_okaybutton.png');
    this.load.image('rewardEarned', 'assets/EndSceneAssets/Rewards earned!.png');
    this.load.image('compass', 'assets/EndSceneAssets/compass.png');
    this.load.image('rewardName', 'assets/EndSceneAssets/lantern.png');
    this.load.multiatlas(
      'endConfetti',
      'assets/EndSceneAssets/confetti/confettiAnimNew.json',
      'assets/EndSceneAssets/confetti',
    );
    this.load.multiatlas(
      'glitter',
      'assets/anims/rewardAnims/glitterAnim.json',
      'assets/anims/rewardAnims/',
    );
    this.load.multiatlas(
      'baseCircle',
      'assets/anims/rewardAnims/baseCircleAnim.json',
      'assets/anims/rewardAnims/',
    );

    this.load.start();

    this.loadcomplete = false;
    this.load.on(
      'complete',
      function () {
        this.loadcomplete = true;
      },
      this,
    );

    cam = this.cameras.main;
    this.add.sprite(0, 0, 'bg').setOrigin(0);
    this.light = this.add.sprite(590, 40, 'light').setOrigin(0).setAlpha(0);
    this.bulb = this.add.sprite(642.89, 0, 'bulb').setOrigin(0);
    this.play = this.add
      .sprite(650, 630, 'play')
      .setOrigin(0.5)
      .setInteractive({ cursor: 'pointer' });

    this.anims.create({
      key: 'vinnieAnimIdle',
      frames: this.anims.generateFrameNames('vinnieAnim', {
        start: 0,
        end: 70,
        zeroPad: 0,
        prefix: 'vinnieChar',
        suffix: '.png',
      }),
      frameRate: 24,
      repeat: -1,
    });

    this.anims.create({
      key: 'vinnieAnimSwitchOn',
      frames: this.anims.generateFrameNames('vinnieAnim', {
        start: 71,
        end: 118,
        zeroPad: 0,
        prefix: 'vinnieChar',
        suffix: '.png',
      }),
      frameRate: 24,
      repeat: 0,
    });

    this.vinnieAnimIdle = this.add
      .sprite(645, 352, 'vinnieAnimIdle')
      .play('vinnieAnimIdle');

    this.play.on(
      'pointerover',
      function () {
        this.play.setTexture('playBlack');
      },
      this,
    );

    this.play.on(
      'pointerout',
      function () {
        this.play.setTexture('play');
      },
      this,
    );

    this.play.on(
      'pointerdown',
      function () {
        this.tweens.add({
          targets: this.play,
          scale: 0.8,
          ease: 'linear',
          duration: 150,
          delay: 25,
          yoyo: true,
          repeat: 0,
          onComplete: () => {
            this.vinnieAnimIdle.setTexture('vinnieAnimSwitchOn');
            this.vinnieAnimIdle.anims.play('vinnieAnimSwitchOn');
            this.time.delayedCall(
              400,
              () => {
                this.tweens.add({
                  targets: this.light,
                  delay: 100,
                  alpha: { from: 0, to: 1 },
                  ease: 'Power1',
                  duration: 500,
                  repeat: 0,
                  yoyo: false,
                });
                this.play.setVisible(false);
              },
              [],
              this,
            );
          },
        });

        this.vinnieAnimIdle.on(
          Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'vinnieAnimSwitchOn',
          () => {
            cam.fadeOut(200, 255, 255, 255);
            cam.once(
              'camerafadeoutcomplete',
              function () {
                this.scene.start('GameScene');
                this.scene.stop('StartScene');
              },
              this,
            );
          },
          this,
        );
      },
      this,
    );
  }

  update() {}
}
